// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { overhaulTypeApi } from '../../lib/api';
import { type OverhaulType } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/overhaul-types/';

export default (props: PageProps) => {
  const [data: OverhaulType, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await overhaulTypeApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: OverhaulType) => {
    let id = payload.id;
    if (id) {
      await overhaulTypeApi.update(payload);
    } else {
      let data = await overhaulTypeApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: OverhaulType) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Виды работ по капитальному ремонту ТС'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
